module.exports = __webpack_public_path__ + "assets/img/learning_word.0eba43c7.png";